import { Button } from "react-bootstrap";
import { VscEye } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import IconText from "./IconText";

const DetailButton = ({ url, openInNewWindow = false }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (openInNewWindow) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      navigate(url);
    }
  };
  return (
    <Button variant="default" size="sm" onClick={handleClick}>
      <IconText icon={<VscEye />} />
    </Button>
  );
};

export default DetailButton;
